export default __webpack_public_path__ + "static/media/close-icon.1d1a9874.svg";